export default function ConnectButton() {
  return (
    <div>
      <w3m-button size='md' balance='hide'/>
    </div>
  );
}
